// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-cards {
    justify-content: center;
    flex-flow: column;
    width: 1420px
}

.no-cards h3 {
    color: #3d3d3d;
    margin: 0;
    text-align: center
}

.template-button-container {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    margin-top: 10px
}

.template-button-container:hover {
    cursor: pointer;
}

.template-button-text {
    margin-left: 10px;
    color: #1976d2;
    font-size: 18px
}

.no-data-template-icon {
    width: 22px;
}

@media screen and (min-width: 1350px) and (max-width: 1920px) {
    .no-cards {
        width: 1100px;
        min-height: 91.5%;
    }
}

@media screen and (min-width: 1050px) and (max-width: 1349px) {
    .no-cards {
        width: 850px;
    }
}

@media screen and (min-width: 720px) and (max-width: 1049px) {
    .no-cards {
        width: 580px;
    }
}

@media screen and (min-width: 600px) and (max-width: 720px) {
    .no-cards {
        width: 500px;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/css/data-unavailable-component.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,iBAAiB;IACjB;AACJ;;AAEA;IACI,cAAc;IACd,SAAS;IACT;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,aAAa;QACb,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":[".no-cards {\n    justify-content: center;\n    flex-flow: column;\n    width: 1420px\n}\n\n.no-cards h3 {\n    color: #3d3d3d;\n    margin: 0;\n    text-align: center\n}\n\n.template-button-container {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    justify-content: center;\n    margin-top: 10px\n}\n\n.template-button-container:hover {\n    cursor: pointer;\n}\n\n.template-button-text {\n    margin-left: 10px;\n    color: #1976d2;\n    font-size: 18px\n}\n\n.no-data-template-icon {\n    width: 22px;\n}\n\n@media screen and (min-width: 1350px) and (max-width: 1920px) {\n    .no-cards {\n        width: 1100px;\n        min-height: 91.5%;\n    }\n}\n\n@media screen and (min-width: 1050px) and (max-width: 1349px) {\n    .no-cards {\n        width: 850px;\n    }\n}\n\n@media screen and (min-width: 720px) and (max-width: 1049px) {\n    .no-cards {\n        width: 580px;\n    }\n}\n\n@media screen and (min-width: 600px) and (max-width: 720px) {\n    .no-cards {\n        width: 500px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
